export default {
    namespaced: true,
    state: () => ({
        videosClicked: 0,
        timeSpent: 0
    }),
    mutations: {
        SET_VIDEOS_CLICKED(state, count) {
            state.videosClicked = count;
        },
        SET_TIME_SPENT(state, time) {
            state.timeSpent = time;
        }
    },
    actions: {},
    getters: {
        videosClicked: (state) => state.videosClicked,
        timeSpent: (state) => state.timeSpent
    }
};
